// extracted by mini-css-extract-plugin
module.exports = {"container":"menuList_container__4G9r9","link":"menuList_link__xoZAk","line":"menuList_line__hXa14","wide":"menuList_wide__w5oCu"};